module.exports = __webpack_public_path__ + "static/media/susess-animation.e8955fbf.gif";